<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    placeholder="请选择门店"
    :clearable="clearable"
    idKey="RecordId"
    labelKey="StoreName"
    :get-data-func="getDataFunc"
    :disabled="disabled"
  />
</template>
<script>
import api from "@/api/shop/store";
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: { commonSelect },
  data() {
    return { api };
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve, reject) => {
        this.api.list({ Status: 1 }).then((res) => {
          // console.log(res.Data);
          resolve({ Data: res.Data });
        });
      });
    },
  },
};
</script>

